import { api } from './api';
import { unwrapList } from './unwrapList';
import { Notification, NotificationApiResponse, mapNotificationFromApi } from '../types/notification';

interface UnreadCountResponse {
  count: number;
}

interface MarkAsReadResponse {
  success: boolean;
  updated: number;
}

interface DeleteResponse {
  success: boolean;
}

export const NotificationService = {
  async getNotifications(): Promise<Notification[]> {
    const response = await api.get<{ data: NotificationApiResponse[] } | NotificationApiResponse[]>('/notifications');
    return unwrapList<NotificationApiResponse>(response.data).map(mapNotificationFromApi);
  },

  async getUnreadCount(): Promise<number> {
    const response = await api.get<UnreadCountResponse>('/notifications/unread-count');
    return response.data.count;
  },

  async markAsRead(ids?: number[]): Promise<MarkAsReadResponse> {
    const response = await api.post<MarkAsReadResponse>('/notifications/read', { ids });
    return response.data;
  },

  async markAllAsRead(): Promise<MarkAsReadResponse> {
    const response = await api.post<MarkAsReadResponse>('/notifications/read', {});
    return response.data;
  },

  async deleteNotification(id: number): Promise<DeleteResponse> {
    const response = await api.delete<DeleteResponse>(`/notifications/${id}`);
    return response.data;
  },
};

export default NotificationService;
